import React from 'react';
import { ErrorMessage } from 'formik';
import NumberFormat from 'react-number-format';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import { getDecimalSeparator, getThousandSeparator } from '../../../utils/Functions';
import LabelR from '../../Simple/LabelR';

const NumberInput = (props) => {
  const {
    field: { name, value, onBlur },
    form: { touched, errors, setFieldValue },
    label,
    disabled = false,
    placeholder,
    autoComplete,
    intl,
    addOn,
    required,
  } = props;

  const decimalSeparator = getDecimalSeparator(intl.locale);
  const groupSeparator = getThousandSeparator(intl.locale);

  const classes = classNames('form-control', {
    'is-invalid': errors[name] && touched[name],
  });

  const valueChange = (name, v) => {
    const value = v.floatValue ? v.floatValue : v.value;
    setFieldValue(name, value);
  };
  const input = (
    <NumberFormat
      name={name}
      id={`${name}-input`}
      value={value}
      autoComplete={autoComplete}
      onValueChange={(v) => {
        valueChange(name, v);
      }}
      thousandSeparator={groupSeparator}
      decimalSeparator={decimalSeparator}
      className={classes}
      placeholder={placeholder}
      disabled={disabled}
      onBlur={onBlur}
    />
  );

  return (
    <div className="form-group" id={`${name}-container-input`}>
      {label &&
        (required ? (
          <LabelR isEditable={!disabled} htmlFor={name} name={name}>
            {label}
          </LabelR>
        ) : (
          <label htmlFor={name} id={`${name}-label`}>
            {label}
          </label>
        ))}
      {addOn ? (
        <div className="input-group">
          <div className="input-group-append">
            <span className="input-group-text" id="basic-addon2">
              {addOn}
            </span>
          </div>
          {input}
        </div>
      ) : (
        input
      )}
      {touched[name] && errors[name] && <ErrorMessage name={name} component="div" className="invalid-feedback" />}
    </div>
  );
};

export default compose(injectIntl)(NumberInput);
